'use client';

import { useState, useRef } from 'react';
import useIsomorphicLayoutEffect from './useIsomorphicLayoutEffect.js';

var IS_SERVER = typeof window === 'undefined';
function useScrollLock(options) {
    if (options === void 0) { options = {}; }
    var _a = options.autoLock, autoLock = _a === void 0 ? true : _a, lockTarget = options.lockTarget, _b = options.widthReflow, widthReflow = _b === void 0 ? true : _b;
    var _c = useState(false), isLocked = _c[0], setIsLocked = _c[1];
    var target = useRef(null);
    var originalStyle = useRef(null);
    var lock = function () {
        if (target.current) {
            var _a = target.current.style, overflow = _a.overflow, paddingRight = _a.paddingRight;
            // Save the original styles
            originalStyle.current = { overflow: overflow, paddingRight: paddingRight };
            // Prevent width reflow
            if (widthReflow) {
                // Use window inner width if body is the target as global scrollbar isn't part of the document
                var offsetWidth = target.current === document.body ? window.innerWidth : target.current.offsetWidth;
                // Get current computed padding right in pixels
                var currentPaddingRight = parseInt(window.getComputedStyle(target.current).paddingRight, 10) || 0;
                var scrollbarWidth = offsetWidth - target.current.scrollWidth;
                target.current.style.paddingRight = "".concat(scrollbarWidth + currentPaddingRight, "px");
            }
            // Lock the scroll
            target.current.style.overflow = 'hidden';
            setIsLocked(true);
        }
    };
    var unlock = function (mode) {
        if (mode === void 0) { mode = 'hard'; }
        if (target.current && originalStyle.current) {
            var initStyles = { overflow: '', paddingRight: '' };
            if (mode === 'soft') {
                initStyles = originalStyle.current;
            }
            target.current.style.overflow = initStyles.overflow;
            // Only reset padding right if we changed it
            if (widthReflow) {
                target.current.style.paddingRight = initStyles.paddingRight;
            }
        }
        setIsLocked(false);
    };
    useIsomorphicLayoutEffect(function () {
        if (IS_SERVER)
            return;
        if (lockTarget) {
            target.current = typeof lockTarget === 'string' ? document.querySelector(lockTarget) : lockTarget;
        }
        if (!target.current) {
            target.current = document.body;
        }
        if (autoLock) {
            lock();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [autoLock, lockTarget, widthReflow]);
    return { isLocked: isLocked, lock: lock, unlock: unlock };
}

export { useScrollLock as default };
//# sourceMappingURL=useScrollLock.js.map
